/**
 * @typedef {Object} MteVariant
 * @property {number} id
 * @property {string[]} options
 * @property {number} price
 * @property {number|null} compare_at_price
 * @property {boolean} available
 * @property {string|null} sku
 */

document.addEventListener("DOMContentLoaded", () => {
  /** @type {NodeListOf<HTMLElement>} */
  const productSections = document.querySelectorAll("[data-mte-product]");

  productSections.forEach((section) => {
    /** @type {HTMLScriptElement|null} */
    const variantsElement = section.querySelector("[data-mte-product-json]");

    /** @type {HTMLInputElement|null} */
    const variantInput = section.querySelector("[data-mte-variant-id]");

    /** @type {HTMLElement|null} */
    const priceContainer = section.querySelector("[data-mte-product-price]");

    /** @type {HTMLElement|null} */
    const availability = section.querySelector(
      "[data-mte-product-availability]",
    );

    /** @type {HTMLButtonElement|null} */
    const addButton = section.querySelector("[data-mte-add-button]");

    /** @type {HTMLElement|null} */
    const addText = section.querySelector("[data-mte-add-text]");

    /** @type {HTMLElement|null} */
    const sku = section.querySelector("[data-mte-product-sku]");

    /** @type {NodeListOf<HTMLInputElement>} */
    const optionInputs = section.querySelectorAll("[data-mte-option]");

    /** @type {HTMLInputElement|null} */
    const quantityInput = section.querySelector("[data-mte-quantity]");

    /** @type {HTMLButtonElement|null} */
    const minusButton = section.querySelector("[data-mte-quantity-minus]");

    /** @type {HTMLButtonElement|null} */
    const plusButton = section.querySelector("[data-mte-quantity-plus]");

    /** @type {MteVariant[]} */
    let variants = [];

    try {
      variants = JSON.parse(variantsElement?.textContent || "[]");
    } catch (error) {
      console.error(
        "No se pudieron cargar las variantes del producto.",
        error,
      );
    }

    /**
     * @param {number} cents
     * @returns {string}
     */
    const formatMoney = (cents) => {
      return new Intl.NumberFormat("es-PA", {
        style: "currency",
        currency: "USD",
      }).format(cents / 100);
    };

    /**
     * @returns {string[]}
     */
    const getSelectedOptions = () => {
      /** @type {string[]} */
      const selections = [];

      /** @type {NodeListOf<HTMLInputElement>} */
      const checkedOptions = section.querySelectorAll(
        "[data-mte-option]:checked",
      );

      checkedOptions.forEach((input) => {
        const position = Number(input.dataset.optionPosition);

        if (position > 0) {
          selections[position - 1] = input.value;
        }
      });

      return selections;
    };

    const updateVariant = () => {
      const selections = getSelectedOptions();

      const matchedVariant = variants.find((variant) =>
        variant.options.every(
          (option, index) => option === selections[index],
        ),
      );

      if (!matchedVariant) {
        if (addButton) {
          addButton.disabled = true;
        }

        if (addText) {
          addText.textContent = "Combinación no disponible";
        }

        return;
      }

      if (variantInput) {
        variantInput.value = String(matchedVariant.id);
      }

      if (sku) {
        sku.textContent = matchedVariant.sku || "No disponible";
      }

      if (priceContainer) {
        let priceMarkup = `
          <span class="mte-product-info__current-price">
            ${formatMoney(matchedVariant.price)}
          </span>
        `;

        if (
          matchedVariant.compare_at_price &&
          matchedVariant.compare_at_price > matchedVariant.price
        ) {
          const discount = Math.round(
            ((matchedVariant.compare_at_price - matchedVariant.price) /
              matchedVariant.compare_at_price) *
              100,
          );

          priceMarkup += `
            <s class="mte-product-info__compare-price">
              ${formatMoney(matchedVariant.compare_at_price)}
            </s>

            <span class="mte-product-info__discount">
              Ahorras ${discount}%
            </span>
          `;
        }

        priceContainer.innerHTML = priceMarkup;
      }

      if (availability) {
        availability.classList.toggle(
          "is-sold-out",
          !matchedVariant.available,
        );

        availability.innerHTML = matchedVariant.available
          ? "<span></span>Disponible para compra"
          : "<span></span>Producto agotado";
      }

      if (addButton) {
        addButton.disabled = !matchedVariant.available;
      }

      if (addText) {
        addText.textContent = matchedVariant.available
          ? "Agregar al carrito"
          : "Agotado";
      }

      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set("variant", String(matchedVariant.id));
      window.history.replaceState({}, "", newUrl);
    };

    optionInputs.forEach((input) => {
      input.addEventListener("change", updateVariant);
    });

    minusButton?.addEventListener("click", () => {
      if (!quantityInput) return;

      const currentValue = Math.max(
        1,
        Number(quantityInput.value || 1),
      );

      quantityInput.value = String(Math.max(1, currentValue - 1));
    });

    plusButton?.addEventListener("click", () => {
      if (!quantityInput) return;

      const currentValue = Math.max(
        1,
        Number(quantityInput.value || 1),
      );

      quantityInput.value = String(currentValue + 1);
    });

    /** @type {NodeListOf<HTMLButtonElement>} */
    const thumbnails = section.querySelectorAll(
      "[data-mte-product-thumbnail]",
    );

    /** @type {NodeListOf<HTMLElement>} */
    const slides = section.querySelectorAll(
      "[data-mte-product-slide]",
    );

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        const mediaId = thumbnail.dataset.mediaId;

        if (!mediaId) return;

        thumbnails.forEach((item) => {
          item.classList.remove("is-active");
        });

        slides.forEach((slide) => {
          slide.classList.remove("is-active");
        });

        thumbnail.classList.add("is-active");

        /** @type {HTMLElement|null} */
        const selectedSlide = section.querySelector(
          `[data-mte-product-slide][data-media-id="${mediaId}"]`,
        );

        selectedSlide?.classList.add("is-active");
      });
    });
  });
});
